<template>
  <div class="Readily">
    <div class="content">
      <component
        :is="path"
        ref="editOrCreate"
        style="background: #fff;"
        :form-type="formType"
        :method-path="methodPath"
        @reFresh="reFresh"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: { },
  data() {
    var checkTel = (rule, value, callback) => { // 编辑验证
      const re = /^1[3456789]{1}\d{9}$/
      if (!re.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      }
      callback()
    }
    var options = [{ name: '选项一', id: '1' }, { name: '选项二' }, { name: '选项三' }]
    return {
      methodPath: { // 接口必传
        create: 'home/ReadilyAddReadily' // 创建接口
      },
      path: () => import('@/components/tableComponent/editOrCreate.vue'), // 编辑页面,如需要自定义可以引用自己的文件
      formType: {
        title: {
          label: '民情简介',
          message: '请输入民情简介'
        },
        contacts: { label: '联系人', message: '请输入联系人' },
        tel: { label: '联系电话', validator: checkTel },
        reportType: { label: '类型', type: 'select', options, message: '请选择类型', valUseName: true }, // 下拉选择
        context: { // 富文本
          label: '内容',
          type: 'rich',
          message: '请输入内容'
        }
      }
    }
  },

  mounted() {

  },
  created() {
    this.getTypeList() // 获取下拉分类
  },

  methods: {
    getTypeList() {
      this.$store.dispatch('home/ReadilyGetReadilyType').then(res => {
        if (res.code === 0) {
          this.formType.reportType.options = res.data
        }
      })
    },
    reFresh() {
      this.$go('/mine/Readily')
    }
  }
}
</script>

<style lang="scss" scoped>
  .Readily{
    background: #f5f9fa;
    flex: 1;
    .content{
      display: flex;
      flex-direction: column;
      background: #fff;
    }
  }
</style>
